export default __webpack_public_path__ + "static/media/covid19Tracker_LogoSML.3a8d12c1.png";